import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { ShippingMethodInfo } from "../../../../../components/StepShipping/modules/ShippingMethods/components/ShippingMethodInfo.js";
import { mapShippingMethods } from "../../../../../../../../mappers/view/mappers/view/shipping-methods.js";
import { ShippingMethodsList } from "../../../../../components/StepShipping/modules/ShippingMethods/components/ShippingMethodsList.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const ShippingMethodsListContainer = ({
  shippingMethodList,
  asides,
  onChange,
  selectedShippingMethod,
  handleOnShippingMethodSelected,
  isLoading,
  error
}) => {
  const { getLabel, locale } = useIntl();
  const { shippingMethodsLogos } = useCheckoutSettings();
  const labels = React.useMemo(
    () => ({
      errorTitle: getLabel("checkout.errors.general.title"),
      errorMessage: getLabel("checkout.errors.general.message"),
      free: getLabel("common.free"),
      required: getLabel("common.form.field.requiredError")
    }),
    [getLabel]
  );
  const shippingMethodInfo = ({ price, logo, isFree }) => /* @__PURE__ */ React.createElement(ShippingMethodInfo, { price, logo, isFree });
  const items = mapShippingMethods({
    asides,
    logos: shippingMethodsLogos,
    locale,
    shippingMethodList,
    shippingMethodInfo
  });
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
  if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { variant: "error", title: labels.errorTitle, className: "alert-m-default" }, labels.errorMessage);
  }
  const hasValidationError = !selectedShippingMethod?.isValid && selectedShippingMethod?.isTouched;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ShippingMethodsList,
    {
      handleChange: (method) => {
        onChange?.();
        handleOnShippingMethodSelected?.(method);
      },
      shippingMethodItems: items,
      selectedShippingMethod: selectedShippingMethod?.method ? selectedShippingMethod?.method : "",
      hasValidationError
    }
  ), hasValidationError && /* @__PURE__ */ React.createElement(Text, { className: "form-control__error" }, labels.required));
};
export {
  ShippingMethodsListContainer
};
//# sourceMappingURL=ShippingMethodsListContainer.js.map
